import { DiscountTypes } from "@/common/enums";

export default class MiClubSettingsModel {    
    isEnabled: boolean = false;
    apiEndpoint: string = "";    
    username: string = "";
    password: string = "";
    accountTypeId: number = 0;
    locationId: number = 0;
    
}
